import { LogDataTransport } from "logging/LogDataTransport";
import $ from "jquery";
import CookieHelper from "base/CookieHelper";
import Ajax from "base/Ajax";

export default class BeaconLogTransport extends LogDataTransport {

    constructor() {
        super();
        this.queue = [];

        this.flushTimeout = null;

        // Flush the queue before we unload the page
        $(window).on("beforeunload", () => {
            this.flushQueue();
        });
    }

    sendLog(logData) {
        console.debug("Log data pushed to queue", logData);
        this.queue.push(logData);

        if (this.flushTimeout === null) {
            // Flush the queue at least once every 30 seconds
            this.flushTimeout = setTimeout(() => {
                this.flushQueue();
            }, 30 * 1000 /* 30 seconds */);
        }

        if (this.queue.length > 10) {
            this.flushQueue();
        }
    }


    /**
     * Send all the stored logs currently on the queue to the server
     */
    flushQueue() {
        if (this.flushTimeout) {
            clearTimeout(this.flushTimeout);
            this.flushTimeout = null;
        }

        if (this.queue.length === 0) {
            return;
        }

        try {
            let formData = new FormData;
            formData.append('_json', JSON.stringify({
                lines: this.queue,
                csrf: CookieHelper.get("csrf"),
            }));

            if (!navigator.sendBeacon(Ajax.getBaseUrl(Ajax.WEBSITE) + 'base/logging/batch', formData)) {
                console.log("Couldn't send beacon request");
            }

            this.queue = [];
        } catch (e) {
            console.log("Couldn't process log queue", e);
        }
    }
}
